// Editable fields from the Operational Lookup API handoff.
const fields = [
    {
        "name": "stateId",
        "label": "State",
        "type": "lookup-select",
        "required": true,
        "source": "operational-states",
        "labelField": "stateName",
        "stateGuidField": "enerexStateIdentifier",
        "lockOnEdit": true
    },
    {
        "name": "stateName",
        "type": "hidden"
    },
    {
        "name": "enerexStateIdentifier",
        "type": "hidden"
    },
    {
        "name": "name",
        "label": "Name",
        "type": "text"
    },
    {
        "name": "aliases",
        "label": "Aliases",
        "type": "hidden"
    },
    {
        "name": "active",
        "label": "Active",
        "type": "nullable-boolean",
        "hidden": true,
        "defaultValue": true
    },
    {
        "name": "deleted",
        "label": "Deleted",
        "type": "nullable-boolean",
        "hidden": true,
        "defaultValue": false
    }
];
export default fields;
